import { render, staticRenderFns } from "./GChatBuyerInfoPc.vue?vue&type=template&id=ac21544c&scoped=true&"
import script from "./GChatBuyerInfoPc.vue?vue&type=script&lang=ts&"
export * from "./GChatBuyerInfoPc.vue?vue&type=script&lang=ts&"
import style0 from "./GChatBuyerInfoPc.vue?vue&type=style&index=0&id=ac21544c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac21544c",
  null
  
)

export default component.exports